// Autoplay para carrusel de colecciones
document.addEventListener('DOMContentLoaded', function () {
  const SECTION_ID = 'template--21948907323645__collection_list_gqQfQ6';
  const INTERVAL_MS = 4000; // Cambia el tiempo en milisegundos (4000 = 4 segundos)

  const section = document.getElementById(SECTION_ID);
  if (!section) return;

  const nextBtn = section.querySelector('.slider-button--next');
  if (!nextBtn) return;

  let autoplay = setInterval(() => nextBtn.click(), INTERVAL_MS);

  // Pausa al pasar el mouse
  section.addEventListener('mouseenter', () => clearInterval(autoplay));
  section.addEventListener('mouseleave', () => {
    autoplay = setInterval(() => nextBtn.click(), INTERVAL_MS);
  });
});